import { render, staticRenderFns } from "./SupervisorDashboard.vue?vue&type=template&id=16ee7d4c&scoped=true"
import script from "./SupervisorDashboard.vue?vue&type=script&lang=js"
export * from "./SupervisorDashboard.vue?vue&type=script&lang=js"
import style0 from "./SupervisorDashboard.vue?vue&type=style&index=0&id=16ee7d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ee7d4c",
  null
  
)

export default component.exports